__webpack_require__.p = "https://cdn.ecopoxy.com/calculator/";